import { Link } from "react-router-dom";

/** Official HonestPay neon wordmark (matches the app mockups). */
const SIZES = { sm: 54, md: 84, lg: 132, xl: 176, hero: 210 };

export function Brand({ size = "md", to = "/", glow = false, float = false }) {
  const h = SIZES[size] ?? SIZES.md;
  const inner = (
    <img
      src="/brand/honestpay-logo-neon.png"
      alt="HonestPay"
      style={{ height: h, width: "auto" }}
      className={`select-none ${glow ? "hp-logo-glow" : ""} ${float ? "hp-float" : ""}`}
      draggable={false}
    />
  );
  return to ? (
    <Link to={to} data-testid="brand-logo" className="inline-flex">
      {inner}
    </Link>
  ) : (
    <div data-testid="brand-logo" className="inline-flex">
      {inner}
    </div>
  );
}

export function BrandGlyph({ size = 44, className = "" }) {
  return (
    <img
      src="/brand/honestpay-icon.png"
      alt="HonestPay"
      style={{ height: size, width: size }}
      className={`rounded-2xl select-none ${className}`}
      draggable={false}
    />
  );
}
